module.exports = __webpack_public_path__ + "img/inspect.a51a3b04.png";